import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CompanyDetails } from "../../data/component/models-interfaces/manage-company/company-interface";
@Injectable({
  providedIn: "root",
})
export class CurrencyService {
  constructor(private httpClient: HttpClient) {}

  getAllCurrencyList(page: any, limit: any, search?: any) {
    const apiUrl = `${environment.serverEndPoint}/currency/list?page=${page}&limit=${limit}&name=${search}`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getCurrency(id: any) {
    const apiUrl = `${environment.serverEndPoint}/currency/` + id;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  createCurrency(data: any) {
    const apiUrl = `${environment.serverEndPoint}/currency/create`;
    return this.httpClient.post<CompanyDetails>(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  updateCurrency(id: any, data: any) {
    const apiUrl = `${environment.serverEndPoint}/currency/update/` + id;
    return this.httpClient.put(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  deleteCurrency(id: any, data: boolean) {
    const sendData = { isDeleted: data };
    const apiUrl = `${environment.serverEndPoint}/currency/status-update/` + id;
    return this.httpClient.put(apiUrl, sendData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getDropdownCurrency() {
    const apiUrl = `${environment.serverEndPoint}/currency/dropdown/list`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }
}
